import { render } from "./AdminComponent.vue?vue&type=template&id=7dcebd23&scoped=true"
import script from "./AdminComponent.vue?vue&type=script&lang=js"
export * from "./AdminComponent.vue?vue&type=script&lang=js"

import "./AdminComponent.vue?vue&type=style&index=0&id=7dcebd23&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7dcebd23"]])

export default __exports__